import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function NoParticipantsWarning() {
  const { t } = useTranslation('shared');
  return (
    <Card sx={{
      backgroundColor: 'rgba(255, 152, 0, 0.1)',
      border: '1px solid #ff9800',
      textAlign: 'center',
      py: 4
    }}>
      <CardContent>
        <WarningAmber sx={{ fontSize: 48, color: '#ff9800', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#ff9800', fontWeight: 'bold' }}>
          {t('noParticipantsWarning.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          {t('noParticipantsWarning.message')}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          {t('noParticipantsWarning.contactSupportPrefix')}{' '}
          <span
            style={{ color: '#2196f3', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => window.Intercom && window.Intercom('show')}
          >
            {t('noParticipantsWarning.contactSupport')}
          </span>
        </Typography>
      </CardContent>
    </Card>
  );
}

export default NoParticipantsWarning;
